<template>
	<div @click="click(data.config.path)" :style="{'textAlign':data.config.textAlign,'background':data.config.containerBgColor ||'','border-radius':data.config.borderRadius+'px','color':data.config.textColor ||'','font-size':data.config.textFontSize+'px','marginTop': data.config.marginTop+'px','marginRight': data.config.marginRight+'px', 'marginBottom': data.config.marginBottom+'px','marginLeft': data.config.marginLeft+'px','paddingTop': data.config.paddingTop+'px','paddingBottom': data.config.paddingBottom+'px','paddingLeft': data.config.paddingLeft+'px','paddingRight': data.config.paddingRight+'px'}">
		{{data.config.textContent}}
	</div>
</template>

<script>
	export default {
		name: 'Tpl_Text',
		props: {
			data: {
				type: Object,
				default: () => ({})
			},
		},
		methods: {
			click(path){
        this.$router.push(path)
			},
		}
	};
</script>

<style scoped>
</style>